/**
 * Convert a template string into HTML DOM nodes
 * @param  {String} str The template string
 * @return {Node}       The template HTML
 */
export function stringToHTML(value) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(value, 'text/html');

	return doc.body;
}

/**
 * Get the description value from an HTML string.
 * @param string
 * @returns {string}
 */
export function getDescriptionFromString(string) {
	try {
		const html = stringToHTML(string);
		let text = html.textContent;
		text = text.replace('\n', '');
		const maxLength = 400;
		const suffix = text.length > maxLength + 3 ? '...' : '';

		return text.substring(0, maxLength) + suffix; // get element directly after description
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export const getChoices = (choices) =>
	choices?.split(',')?.map((choice) => ({ value: choice, content: choice }));

export function createMarkup(description) {
	// Remove unnecessary white space from description.
	const value = description
		?.replace(/&nbsp;/g, '')
		?.replace(/(<br ?\/?>)*/g, '');

	return { __html: value };
}
